import * as React from 'react';
import { Table, CustomButton, ButtonType } from "soprasteria-ui-library";
import { IRiskPotReportNote } from '../../../models/IRiskPotReport';
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { useAuth } from '../../../App';
import { RiskPotReportNoteApi } from '../../../api/RiskPotReportNoteApi';

interface IRiskPotReportNotesTable {
    riskPotReportNotes: IRiskPotReportNote[];
    setSelectedNote: React.Dispatch<React.SetStateAction<IRiskPotReportNote | undefined>>;
    openNoteModalClicked: () => void;
    getRiskPotReport: () => void;
    changeSuccessMessage: (message: string) => void;
    riskPotReportId: number;
}

interface IDeleteStatus {
    isDeleting: boolean;
    key?: number;
}

export const RiskPotReportNotesTable: React.FunctionComponent<IRiskPotReportNotesTable> = ({ riskPotReportNotes, setSelectedNote, openNoteModalClicked, changeSuccessMessage, getRiskPotReport, riskPotReportId }) => {

    const auth = useAuth();
    const api = new RiskPotReportNoteApi(auth)
    const [deleteStatus, setDeleteStatus] = React.useState<IDeleteStatus>();

    const onChangeClick = (riskPotReportNote: IRiskPotReportNote) => {
        if (setSelectedNote) {
            setSelectedNote(riskPotReportNote);
            document.getElementById("open-create-risk-pot-report-note")?.click();
        }
    }

    const deleteNote = (riskPotReportNoteId: number, key: number) => {
        const removeTreatment = window.confirm("Är du säker på att du vill ta bort den här noteringen?");
        if (removeTreatment) {
            setDeleteStatus({ isDeleting: true, key: key });
            api.deleteRiskPotReportNote(riskPotReportNoteId, () => {
                changeSuccessMessage("Noteringen har tagits bort");
                getRiskPotReport();
            }, undefined, () => setDeleteStatus({ isDeleting: false }))
        }
    }

    return (
        <>
            <div className="row panel">
                <div className="col-6 text-left">
                    <h5>Noteringar</h5>
                </div>
                <div className="col-6 text-right">
                    <CustomButton buttonType={ButtonType.create} buttonText="Skapa notering" data-toggle="modal" data-target="#create-risk-pot-report-note" id="open-create-risk-pot-report-note" onClick={() => openNoteModalClicked()} />
                </div>
            </div>
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th>Text</th>
                        <th>Skapad av</th>
                        <th style={{ width: "10%" }}>Skapad datum</th>
                        <th style={{ width: "15%" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        riskPotReportNotes && riskPotReportNotes.length > 0 ?
                            riskPotReportNotes.map((riskPotReportNote, key) =>
                                <tr key={key}>
                                    <td style={{ whiteSpace: "pre-wrap" }}>{riskPotReportNote.text}</td>
                                    <td>{riskPotReportNote.dentist}</td>
                                    <td>{dateTimeToDateString(riskPotReportNote.createdDate)}</td>
                                    <td className="text-center text-nowrap">
                                        {
                                            <>
                                                <CustomButton buttonType={ButtonType.general} buttonText="Ändra"
                                                    onClick={() => onChangeClick(riskPotReportNote)} />
                                                <CustomButton buttonType={ButtonType.delete} buttonText=""
                                                    isLoading={deleteStatus?.isDeleting && deleteStatus?.key === key}
                                                    onClick={() => deleteNote(riskPotReportNote.riskPotReportNoteId, key)} />
                                            </>

                                        }
                                    </td>
                                </tr>
                            )
                            :
                            <tr><td colSpan={4}>Det finns inga noteringar</td></tr>
                    }
                </tbody>
            </Table>
        </>
    )
}